import {
  ADD_APPROVAL_DETAIL,
  CHECK_CREATE_APPROVAL_DETAIL,
  DELETE_APPROVAL_DETAIL,
  GET_ALL_APPROVAL,
  GET_APPROVAL_DETAIL,
  UPDATE_APPROVAL_DETAIL,
  UPDATE_APPROVAL_DETAIL_STATUS,
} from 'apis/GraphQL/Queries/approvalQuery';
import { APPROVAL_VARIABLE } from 'apis/GraphQL/Variables/approval';
import {
  IAddApprovalDetail,
  ICheckCreateApprovalDetail,
  IDeleteApprovalDetail,
  IGetAllApproval,
  IGetApprovalDetail,
  IUpdateApprovalDetail,
  IUpdateStatusApprovalDetail,
} from 'interfaces/Approval';
import axiosGraphQL from './GraphQL/axiosGraphQL';

const ApprovalApi = {
  getAllApproval: (params: IGetAllApproval) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_ALL_APPROVAL,
      variables: APPROVAL_VARIABLE.getAllApproval(params),
    });
  },
  getApprovalDetail: (params: IGetApprovalDetail) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_APPROVAL_DETAIL,
      variables: APPROVAL_VARIABLE.getApprovalDetail(params),
    });
  },
  addApprovalDetail: (params: IAddApprovalDetail) => {
    return axiosGraphQL.post('/graphql', {
      query: ADD_APPROVAL_DETAIL,
      variables: APPROVAL_VARIABLE.addApprovalDetail(params),
    });
  },
  deleteApprovalDetail: (params: IDeleteApprovalDetail) => {
    return axiosGraphQL.post('/graphql', {
      query: DELETE_APPROVAL_DETAIL,
      variables: APPROVAL_VARIABLE.deleteApprovalDetail(params),
    });
  },
  updateApprovalDetail: (params: IUpdateApprovalDetail) => {
    return axiosGraphQL.post('/graphql', {
      query: UPDATE_APPROVAL_DETAIL,
      variables: APPROVAL_VARIABLE.updateApprovalDetail(params),
    });
  },
  checkCreateApprovalDetail: (params: ICheckCreateApprovalDetail) => {
    return axiosGraphQL.post('/graphql', {
      query: CHECK_CREATE_APPROVAL_DETAIL,
      variables: APPROVAL_VARIABLE.checkCreateApprovalDetail(params),
    });
  },
  updateStatusApprovalDetail: (params: IUpdateStatusApprovalDetail) => {
    return axiosGraphQL.post('/graphql', {
      query: UPDATE_APPROVAL_DETAIL_STATUS,
      variables: APPROVAL_VARIABLE.updateStatusApprovalDetail(params),
    });
  },
};

export default ApprovalApi;
